module.exports = __webpack_public_path__ + "img/212.8b2df46d.jpg";